import { render } from "./file-viewer.vue?vue&type=template&id=e2b2c47c"
import script from "./file-viewer.vue?vue&type=script&lang=js"
export * from "./file-viewer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__